var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246.269,
    height: 25.606,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.002,
    y1: 0.315,
    x2: 1.285,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48ff5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48ffc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49666"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49665"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49660"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Powered by",
    transform: "translate(0 18)",
    fill: "#566381",
    fontSize: 14.5,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Powered by")))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Partners Wire",
    transform: "translate(117.269 20)",
    fill: "#566381",
    fontSize: 21,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Partners Wire")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49664"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24095"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24094"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18431",
    d: "M107.052 4.173Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18432",
    d: "M98.524 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18433",
    d: "M108.236 4.801Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18434",
    d: "m1659.189-367.386-.106-.714-.921-6.231c-.145-.973-.294-1.975-.437-2.947l-.016-.114c-.26-1.758-.5-3.416-.688-4.648-.093-.63-.169-1.149-.224-1.513l-.062-.424-.017-.115c-.003-.027 0-.023 0-.03v-.008a1.689 1.689 0 0 0-.131-.456 1.658 1.658 0 0 0-.227-.369 1.707 1.707 0 0 0-.541-.443 1.72 1.72 0 0 0-.644-.188h-.139l-.4-.008-.666-.013-.53-.514-.339-.331-.115-.114-.057-.055-.069-.069-.059-.044a1.967 1.967 0 0 0-.2-.14l-.033-.019-.054-.03-.016-.008-.016-.01a1.978 1.978 0 0 0-.2-.087h-.009l-.035-.013-.078-.027-.112-.027h-.03a2.152 2.152 0 0 0-.427-.044h-.03a4.691 4.691 0 0 0-.447-.634 3.773 3.773 0 0 0-1.224-.97 3.442 3.442 0 0 0-1.115-.327 3.224 3.224 0 0 0-.7-.413 3.344 3.344 0 0 0-1.322-.262h-.11a4.035 4.035 0 0 0-1.292.256 5.129 5.129 0 0 0-1.665 1.046 7.845 7.845 0 0 0-1.325 1.617 10.736 10.736 0 0 0-.927 1.865c-.123.32-.229.641-.318.958l-.711.221c-.191.058-.341.105-.447.139l-.123.038-.033.011h-.017c-.164.052-.311.1-.506.176-.072.032-.154.07-.245.12a2.2 2.2 0 0 0-.249.167 1.832 1.832 0 0 0-.415.456 1.918 1.918 0 0 0-.185.371 2.544 2.544 0 0 0-.114.423 7.135 7.135 0 0 0-.049.316c0 .036-.016.112-.031.232l-.338 2.6-.38 2.942-.975 7.532-.181 1.41 15.626 2.7 4.178-1.04 3.465-.861Zm-9.181-17.832-1.08.334a5.97 5.97 0 0 0-.333-1.992c.831.158 1.24 1.098 1.413 1.658Zm-1.808.56-2.324.719a5.5 5.5 0 0 1 1.172-2.277 2.356 2.356 0 0 1 .79-.576 5.239 5.239 0 0 1 .362 2.134Zm-1.492-2.89a1.124 1.124 0 0 1 .658.172 3.224 3.224 0 0 0-.85.663 6.378 6.378 0 0 0-1.441 3.023l-1.909.592c.376-1.762 1.85-4.402 3.541-4.45Zm8.5 19.477-3.57.887-12.212-2.111c.2-1.5.515-3.984.814-6.29l.05-.385a4980.218 4980.218 0 0 1 .441-3.399c.067-.511.121-.938.163-1.251.011-.085.02-.163.03-.23l1.906-.59.9-.278a.382.382 0 0 0 .043-.013l2.548-.789 2.324-.719 1.031-.319.055-.017.723-.224.854-.263 1.019.989.421.411.589.008h.602l.989 6.693c.143.974.289 1.96.431 2.9.281 1.906.538 3.64.7 4.768Z",
    transform: "translate(-1548.116 389.76)",
    fill: "url(#a)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.40d665095b8ba6a9524e2229eb96a9d3.svg";
export { ForwardRef as ReactComponent };